import loginReduxInterface from "../interfaces/loginInterface"

export const AUTH_TYPES = {
  FETCH: "AUTH/FETCH",
  SUCCESS: "AUTH/SUCCESS",
  FAIL: "AUTH/FAIL",
  RESET: "AUTH/RESET",
};

export const USER = {
  CHANGE: "USER/CHANGE"
}

const initialState = {
  fetch: false,
  user: {},
  token: "",
  authorized: false,
};

export default function (state = initialState, action:loginReduxInterface) {
  switch (action.type) {
    case AUTH_TYPES.FETCH: {
      return {
        ...state,
        fetch: true,
      };
    }
    
    case AUTH_TYPES.SUCCESS: {
      return {
        ...state,
        user: action.payload.user,
        planVenda: action.payload.planVenda,
        authorized: true,
        token: action.payload.token,
        error: false,

      };
    }
    
    case AUTH_TYPES.FAIL: {
      return {
        ...state,
        fetch: false,
      };
    }
    
    case AUTH_TYPES.RESET: {
      return initialState;
    }
    
    case USER.CHANGE: {
      return{
        ...state,
        user: action.payload.user
      }
    }
    
    default:
      return state;
  }
}
